import { ReactNode } from 'react';
import styles from './styles/WebScoreboard.module.scss';
import Scoreboard from '../Scoreboard';
import { ContentSectionFlushContent } from '@/components/ContentSection';
import InfiniteBlockLayout from '../InfiniteBlockLayout';
import useScreenSize from 'hooks/useScreenSize';

export default function WebScoreboard<G extends { id: string | number }>(props: {
  games: G[];
  children: (game: G) => ReactNode;
  injectAtIndex?: (index: number) => ReactNode;
}) {
  return (
    <ContentSectionFlushContent>
      <Scoreboard {...props} className={styles.Scoreboard} injectedClassName={styles.FullWidth} />
    </ContentSectionFlushContent>
  );
}

export function WebScoreboardInfiniteBlocks<G extends { id: string | number }>({
  games,
  children
}: {
  games: G[];
  children: (game: G) => ReactNode;
}) {
  const { isSmallScreen } = useScreenSize();

  return (
    <InfiniteBlockLayout className={styles.Scoreboard} videoIndex={6} blockSize={isSmallScreen ? 6 : 12}>
      {games.map(game => children(game))}
    </InfiniteBlockLayout>
  );
}
